module.exports = __webpack_public_path__ + "img/IMG_9480-1200w.1b55f4cb.jpg";